// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"891":"47992426","949":"bee8e1bd"}[chunkId] + ".chunk.js";
};